import { useMonarch } from "@redventures/cohesion-utils-react";
import { isEmpty } from "lodash";
import { ltoBannerDefaults } from "~/constants/banners";
import { LTOBannerMetadata, OfferMerchMetadata } from "~/types/offerObject";
import { iconMap } from "~/constants/iconMap";
import Stopwatch from "~/components/Icons/outline/Stopwatch";
import { ComponentType } from "react";

type IconProps = {
  className?: string;
};

type LtoBannerReturn = {
  ltoBanner: LTOBannerMetadata;
  Icon: ComponentType<IconProps>;
  ltoBannerText: string;
  ltoBannerCopy: string;
  ltoBannerNgcCopy: string;
  ltoBannerEmphasized: string;
  legalKey: string | undefined; // TODO: check type
  tooltip: string | undefined;
};

const getFirstNonEmptyCopy = (...values: (string | undefined)[]): string =>
  values.find((value) => !isEmpty(value?.trim())) || "";

export const useLTOBanner = (): LtoBannerReturn => {
  // Get data directly from Monarch
  const { result } = useMonarch();

  const ruleData = (result?.source?.cartOfferMerchandisingNgcBau?.value ?? {}) as { data?: OfferMerchMetadata };

  // Use productSelection.ltoBanner or fall back to defaults
  const ltoBanner = ruleData?.data?.productSelection?.ltoBanner || ltoBannerDefaults;

  const legalKey = ltoBanner?.legalKey;
  const Icon = iconMap[ltoBanner?.icon] || Stopwatch;
  const ltoBannerText = `${ltoBanner?.emphasized ? `<b>${ltoBanner?.emphasized}</b><br/>` : ""}${ltoBanner?.copy}`;

  return {
    ltoBanner,
    Icon,
    ltoBannerText,
    ltoBannerCopy: ltoBanner?.copy,
    ltoBannerNgcCopy: getFirstNonEmptyCopy(ltoBanner?.ngcCopy, ltoBanner?.copy),
    ltoBannerEmphasized: ltoBanner?.emphasized,
    legalKey,
    tooltip: !["N/A", "none"].includes(ltoBanner?.tooltip) ? ltoBanner?.tooltip : undefined,
  };
};
